import PropTypes from 'prop-types';

const assetShape = PropTypes.shape({
  path: PropTypes.string.isRequired,
  width: PropTypes.number,
});

export const assetsPropValidation = PropTypes.arrayOf(assetShape);

const imageShape = PropTypes.shape({
  assets: assetsPropValidation.isRequired,
  alt: PropTypes.string,
});

const imageShapeAlt = PropTypes.shape({
  path: PropTypes.string.isRequired,
  alt: PropTypes.string,
});

const imageString = PropTypes.string;

export default PropTypes.oneOfType([imageShape, imageShapeAlt, imageString]);



// WEBPACK FOOTER //
// ./src/utils/imagePropValidation.js